import { render, staticRenderFns } from "./AddClientProfile.vue?vue&type=template&id=8db6a11a&scoped=true"
import script from "./AddClientProfile.vue?vue&type=script&lang=js"
export * from "./AddClientProfile.vue?vue&type=script&lang=js"
import style0 from "./AddClientProfile.vue?vue&type=style&index=0&id=8db6a11a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db6a11a",
  null
  
)

export default component.exports